import { StickyMenu } from './stickyMenu';

export default StickyMenu;
